import { render, staticRenderFns } from "./AdminPoemNew.vue?vue&type=template&id=32c5bfc8&scoped=true&"
import script from "./AdminPoemNew.vue?vue&type=script&lang=js&"
export * from "./AdminPoemNew.vue?vue&type=script&lang=js&"
import style0 from "./AdminPoemNew.vue?vue&type=style&index=0&id=32c5bfc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c5bfc8",
  null
  
)

export default component.exports